import React, { useEffect, useRef, useState } from 'react'
import { donListCol } from '../../../constants/donateListConstants'
import { addBillCols } from '../../../constants/billConstants'
import ProTable from '@ant-design/pro-table'
import { Modal, Select, Space, Button, message, Form, Input, InputNumber, DatePicker } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import './monDonList.less'
import axios from '../../../utils/AxiosUtil'
import moment from 'moment'
// import BatchReverseModal from './batchReverseModal'
// import RelateReverseModal from './relateReverseModal'
// import EditRelRvsModal from './editRelRvsModal'
import { useSelector } from 'react-redux'
import DonationInvoice from './DonationInvoice.tsx'
import DonationInvoiceForman from './DonationInvoiceForman.tsx'
// import { areaObj,IdObj,statusObj } from '../../../../scripts/info'
import { areaObj, IdObj, statusObj, monthstyle, levelObj } from '../../../utils/info'
import j2eUtil from '../../../utils/j2e';
import date2Str from '../../../utils/date2Str';
import printJS from 'print-js'
const { Option } = Select;
const { RangePicker } = DatePicker;

import Invoice from '../../../components/invoice/index.tsx';
import { servedBillCol, htmlstyle, getHtmlStr } from '../../../constants/servedBillConstants'
import { queryAxios, mask, unmask } from '../../../components/reqAndHint'

// 捐款记录页面
export default function list() {
    const langValue = useSelector(state => state.langList.value)
    const actionRef = useRef();
    const formRef = useRef();
    const volunList = useSelector(state => state.volunList.value)
    const [form] = Form.useForm();
    const [addForm] = Form.useForm();

    const [printModalVisible, setPrintModalVisible] = useState();//打印弹窗相关
    const [recordArr, setRecordArr] = useState([])//打印回显相关

    let col = [...donListCol];

    const [fileData, setFileData] = useState([]);
    const [yearData, setYearData] = useState([])
    const [totalCount, setTotalCount] = useState(0);//合计笔数

    const [amount, setAmount] = useState(0);//總金額
    const [areaData, setareaData] = useState([])
    const [projectData, setProjectData] = useState([]);
    const [open, setOpen] = useState(false);//红冲modal显示状态
    const [modalData, setModalData] = useState(null);//红冲数据
    const [redBillCode, setRedBillCode] = useState('');// 红冲票据号码
    const [redBillReason, setRedBillReason] = useState('');// 作废原因

    const [addOpen, setAddOpen] = useState(false); // 新建票据 modal显示状态
    const [billData, setBillData] = useState({});// 新建票据的原票据信息
    const [dateRange, setDateRange] = useState([]);

    const [downloadParams, setDownloadParams] = useState({}); // 下载功能需要的参数

    const [selectedRowKeysArr, setSelectedRowkeysArr] = useState([]);
    const [selectedRowArr, setSelectedRowArr] = useState([]);

    // const [brmVisible, setBrmVisible] = useState(false);//批量红冲明细列表弹窗回显
    // const [rmVisible, setRmVisible] = useState(false);//关联红冲发票弹窗回显
    // const [billDatailList, setBillDetailList] = useState();//批量红冲明细列表
    const [modalVisible, setModalVisible] = useState(false);
    const [modalVisible2, setModalVisible2] = useState(false);
    // const [reverseBillRecord, setReverseBillRecord] = useState();//红冲发票信息
    // const [ermVisible, setErmVisible] = useState(false);//红冲发票已关联票据列表
    // const [areas, setAreas] = useState(null);
    const [choosenArea, setChoosenArea] = useState([]);
    const [choosenProject, setChoosenProject] = useState();
    const [inremark, setInremark] = useState();// 条件查询“备注”的输入内容
    const [volunArr, setVolunarr] = useState([]);//志工信息选择框
    const [volcode, setVolcode] = useState(null);
    const [volname, setVolname] = useState(null);
    const [issend, setIssend] = useState(false);
    const [volEnName, setVolEnName] = useState(null);
    const [remark, setRemark] = useState(null);
    // 年项目报表
    const countHandle = async () => {
        message.destroy();//清空消息提示
        // 生成年份选项，从2025到当前年份，大的年份在上面
        const currentYear = new Date().getFullYear();
        const startYear = 2025;
        const yearOptions = [];
        for (let y = currentYear; y >= startYear; y--) {
            yearOptions.push({
                value: y,
                label: y.toString()
            });
        }

        // 显示年份选择弹窗
        Modal.confirm({
            title: langValue == 0 ? '请选择年份 Please select year' : (langValue == 1 ? '请选择年份' : 'Please select year'),
            content: (
                <Select
                    placeholder={langValue == 0 ? '请选择年份Please select year' : (langValue == 1 ? '请选择年份' : 'Please select year')}
                    style={{ width: 200 }}
                    options={yearOptions}
                    onChange={(value) => {
                        // 保存用户选择的年份
                        Modal.destroyAll();
                        handleYearSelect(value);
                    }}
                    allowClear={false}
                />
            ),
            okText: langValue == 0 ? '确定Yes' : (langValue == 1 ? '确定' : 'Yes'),
            cancelText: langValue == 0 ? '取消Cancel' : (langValue == 1 ? '取消' : 'Cancel'),
            onOk: () => {
                // 点击确定时，如果没有选择年份，不执行任何操作
                return false;
            },
            onCancel: () => {
                // 点击取消时，关闭弹窗
                Modal.destroyAll();
            }
        });

        // 用户选择年份后的处理函数
        async function handleYearSelect(selectedYear) {
            let bdate = selectedYear + '-01-01 00:00:00'
            let edate = selectedYear + '-12-31 24:00:00'
            mask();
            const data = await axios.post('/fund/donation/donationList', { billDate: [bdate, edate], valid: true, purpose: choosenProject, area: choosenArea });
            unmask();
            if (data?.data?.list) {
                let arr = data.data.list
                let len = data.data.list.length
                for (let i = 0; i < len; i++) {
                    arr[i].en_proj = arr[i]['捐款项目']
                    arr[i].en_status = statusObj[arr[i]['状态']]
                }
                setYearData(arr)
                setModalVisible(true)
            }
        }
    }
    // 年捐赠报表 --- 单志工
    const countHandle2 = async () => {
        message.destroy();//清空消息提示
        if (volunArr.length < 1) {
            let msg = langValue == 0 ? <>請選擇地區！<br />Please select region !</> : (langValue == 1 ? '請選擇地區！' : 'Please select region!')
            return message.warn(msg)
        }
        if (!volcode && !volname) {
            let msg = langValue == 0 ? <>志工编号或姓名至少一项不为空！<br />At least one of the volunteer ID or name is not empty!</> : (langValue == 1 ? '志工编号或姓名至少一项不为空！' : 'At least one of the volunteer ID or name is not empty!')
            return message.warn(msg)
        }

        // 生成年份选项，从2025到当前年份，大的年份在上面
        const currentYear = new Date().getFullYear();
        const startYear = 2025;
        const yearOptions = [];
        for (let y = currentYear; y >= startYear; y--) {
            yearOptions.push({
                value: y,
                label: y.toString()
            });
        }

        // 显示年份选择弹窗
        Modal.confirm({
            title: langValue == 0 ? '请选择年份 Please select year' : (langValue == 1 ? '请选择年份' : 'Please select year'),
            content: (
                <Select
                    placeholder={langValue == 0 ? '请选择年份Please select year' : (langValue == 1 ? '请选择年份' : 'Please select year')}
                    style={{ width: 200 }}
                    options={yearOptions}
                    onChange={(value) => {
                        // 保存用户选择的年份
                        Modal.destroyAll();
                        handleYearSelect(value);
                    }}
                    allowClear={false}
                />
            ),
            okText: langValue == 0 ? '确定Yes' : (langValue == 1 ? '确定' : 'Yes'),
            cancelText: langValue == 0 ? '取消Cancel' : (langValue == 1 ? '取消' : 'Cancel'),
            onOk: () => {
                // 点击确定时，如果没有选择年份，不执行任何操作
                return false;
            },
            onCancel: () => {
                // 点击取消时，关闭弹窗
                Modal.destroyAll();
            }
        });

        // 用户选择年份后的处理函数
        async function handleYearSelect(selectedYear) {
            let bdate = selectedYear + '-01-01 00:00:00'
            let edate = selectedYear + '-12-31 24:00:00'
            let dataObj = { billDate: [bdate, edate], valid: true }
            if (volcode) {
                dataObj.volunteerCode = volcode
            }
            if (volname) {
                dataObj.volunteerName = volname
            }
            dataObj.purpose = choosenProject;
            mask();
            const data = await axios.post('/fund/donation/donationList', dataObj);
            unmask();
            if (data?.data?.list) {
                let arr = data.data.list
                let len = data.data.list.length
                for (let i = 0; i < len; i++) {
                    arr[i].en_proj = arr[i]['捐款项目']
                    arr[i].en_status = statusObj[arr[i]['状态']]
                }
                setYearData(arr)
                setModalVisible2(true)
            }
        }
    }
    // 监听地区改变
    const selectArea = (value) => {
        message.destroy();//清除消息提示
        console.log('**selectArea:', value)
        let idarr = value.map(item => {
            let str = item.split('-')[0]
            return str
        })
        // console.log(volunList);
        // area_code和志工的地區書軒相同
        const selectVolarr = volunList.filter(item => idarr.includes(item.area))
        // console.log(selectVolarr);
        setVolunarr(selectVolarr)
        // formRef.current.resetFields()
        actionRef.current.reload()
        let arr = value.map(item => item.split('-').join(' '))
        setChoosenArea(arr);
    }
    const InvoicePrint = () => {
        printJS({
            printable: 'monthInvoice',
            type: 'html',
            targetStyles: ['*'],
            documentTitle: `发票`,
            scanStyles: false,
            style: monthstyle
        })
    }
    // 下载excel
    // const handleDownload = async () => {
    //     mask();
    //     let dataObj = {...downloadParams}
    //     dataObj.langValue = langValue
    //     axios({
    //         url: '/fund/donation/donationRecordExcel', //调用的接口，该接口返回文件流
    //         method: 'post',
    //         data: dataObj,
    //         responseType: 'blob',
    //         timeout: 120000,
    //     }).then((response) => {
    //         // console.log('downloadExcel response:', response);
    //         unmask();
    //         const url = window.URL.createObjectURL(new Blob([response.data]));
    //         const link = document.createElement('a');
    //         link.href = url;
    //         let fileName = '捐款记录 ' + moment().format('YYYY-MM-DD HH：mm：ss') + '.xlsx';
    //         link.setAttribute('download', fileName); //下载后的文件名为fileName
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //         message.destroy();
    //         message.info(langValue==0?<>请在浏览器下方查看文件，并等待下载完成<br/>Please view the file below the browser and wait for the download to complete</>:(langValue==1?'请在浏览器下方查看文件，并等待下载完成':'Please view the file below the browser and wait for the download to complete'), 10);

    //     }).catch(e => {
    //         unmask();
    //         console.log('handleDownload:', e);
    //         Modal.error({ title: langValue==0?'出错了Error':(langValue==1?'出错了':'Error') })
    //     });

    // }
    const handleDownload = () => {
        mask()
        try {
            let excelData = [];
            let title1 = ['志工编号', '英文名', '英文中名', '英文姓', '中文名', '性别', '地区', '级别', '成员', '金额'];
            let title2 = ['Commissioner Number', 'firstName', 'middleName', 'surName', 'Chinese Name', 'Gender', 'Area', 'Stage', 'Members', 'Amount']
            let dateStr
            if (dateRange) {
                let start = date2Str.format(dateRange[0], 'yyyy/MM/dd');
                let end = date2Str.format(dateRange[1], 'yyyy/MM/dd');
                dateStr = [start + '-' + end];
            } else {
                dateStr = [''];
            }
            if (langValue == 2) {
                excelData.push(title2);
            } else {
                excelData.push(title1);
            }
            let len = fileData.length
            let manarr = []
            for (let i = 0; i < len; i++) {
                // 按不同志工统计
                let item = fileData[i]
                let index = manarr.findIndex(item2 => item2.code == item['志工编号'])
                let money = item['票据金额']
                let member = item['票据名称']
                if (index != -1) {
                    manarr[index].total += money
                    if (!(manarr[index].memberArr.includes(member))) {
                        manarr[index].memberArr.push(member)
                    }
                } else {
                    manarr.push({
                        maninfo: item,
                        code: item['志工编号'],
                        total: money,
                        memberArr: [member]
                    })
                }
            }
            let len2 = manarr.length
            for (let i = 0; i < len2; i++) {
                let item = manarr[i]
                let en_gender = item.maninfo.gender == '男' ? 'Male' : 'Female'
                let gender = langValue == 2 ? en_gender : item.maninfo.gender
                let level = langValue == 2 ? levelObj[item.maninfo.level].en_label : levelObj[item.maninfo.level].label
                let row = [item.code, item.maninfo.first_name, item.maninfo.middle_name, item.maninfo.surname, item.maninfo['志工姓名'], gender, item.maninfo['地区'], level, item.memberArr.length, item.total]
                excelData.push(row);
            }
            let fileName = (langValue == 2 ? 'Member Activity Report ' : '會員活動報告 ') + date2Str.format(new Date(), 'yyyy-MM-dd HH：mm：ss') + '.xlsx';
            j2eUtil.j2e(excelData, fileName)
            unmask();
            message.info(langValue == 0 ? <>請在瀏覽器下載列表查看，並等待下載完成<br />Please view the file from the browser download list and wait for the download to complete</> : (langValue == 1 ? '請在瀏覽器下載列表查看，並等待下載完成' : 'Please view the file from the browser download list and wait for the download to complete'), 10);
        } catch (err) {
            unmask();
            console.log(err);
            message.error(langValue == 0 ? '下載失敗Download failed' : (langValue == 1 ? '下載失敗' : 'Download failed'), 2);
        }
    }

    // 提交红冲发票
    const onFinish = (value) => {
        console.log('onFinish:', value);

        value.bill_date = moment().format('YYYY-MM-DD');
        // 补全后端需要的参数
        Object.assign(value, modalData)

        addReverseBillDetail(value);

        // Modal.confirm({
        //     title: langValue == 0 ? '确定要提交吗？Are you sure you want to submit?' : (langValue == 1 ? '确定要提交吗？' : 'Are you sure you want to submit?'),
        //     onOk: () => {
        //         addReverseBillDetail(value);
        //     },
        //     okText: langValue == 0 ? '确定Yes' : (langValue == 1 ? '确定' : 'Yes')
        // })
    }

    const addReverseBillDetail = async (value) => {
        let { data } = await axios.post('/fund/billmgt/addReverseBill', value);
        // console.log('addReverseBill:', data);

        if (data?.code == 1) {
            let { ch_word, en_word, credit_code, address } = data;
            Modal.info({
                title: langValue == 0 ? (data?.msg + data.en_msg) : (langValue == 1 ? data?.msg : data.en_msg),
                okText: langValue == 0 ? '打印发票Print invoice' : (langValue == 1 ? '打印发票' : 'Print invoice'),
                onOk: () => {
                    // 关闭红冲modal 开启新建modal
                    setOpen(false);
                    form.resetFields();
                    let name = value['票据名称'];
                    let purpose = value['捐款项目'];
                    let amount = value['票据金额'];
                    let date = value['bill_date'];
                    let bill_code = value['bill_code'];
                    // let purpose = value[''];
                    // let purpose = value[''];
                    // let purpose = value[''];

                    setRecordArr([{
                        "交款人/单位": name,
                        "用途": purpose,
                        "票据号码": bill_code,
                        "开票日期": date,
                        "合计金额": amount,
                        "纳税人识别号": credit_code,
                        "交款人地址": address,
                        ch_word,
                        en_word,
                    }])
                    setPrintModalVisible(true);
                    // 新建票据的回显
                    // queryBill();
                },
                // cancelText: langValue == 0 ? '不打印No print' : (langValue == 1 ? '不打印' : 'No print'),
                // onCancel: () => {
                //     // 关闭modal 清空表单 刷新页面
                //     setOpen(false);
                //     form.resetFields();
                //     actionRef.current.reload();
                // }
            })

        } else {
            Modal.error({ title: langValue == 0 ? '提交失败Submission failed' : (langValue == 1 ? '提交失败' : 'Submission failed'), okText: langValue == 0 ? '确定Yes' : (langValue == 1 ? '确定' : 'Yes') })
        }

    }

    const queryBill = async () => {
        // console.log('modalData', modalData);
        let { data } = await axios.post('/fund/billmgt/queryBillDetailById', {
            bill_detail_id: modalData.bill_detail_id,
            bill_date: modalData['开立日'],
        });
        // console.log(data);

        if (data?.data) {
            var dataarr = data.data
            dataarr.forEach(d => {
                d.en_proj = d.purpose
                // d.en_Id = IdObj[d.ch_Id]
            })
            setBillData(dataarr);
            addForm.setFieldsValue(dataarr);
            addForm.setFieldsValue({
                bill_date: moment().format('YYYY-MM-DD')
            });
        } else {
            message.info(langValue == 0 ? '查询失败Query failed' : (langValue == 1 ? '查询失败' : 'Query failed'))
        }
    }


    // 红冲功能的新建票据提交
    const addOnFinish = (value) => {
        // console.log('addOnFinish:', value);
        Modal.confirm({
            title: langValue == 0 ? '确定要提交吗？Are you sure you want to submit?' : (langValue == 1 ? '确定要提交吗？' : 'Are you sure you want to submit?'),
            onOk: () => { addNewBill(value) },
            okText: langValue == 0 ? '确定Yes' : (langValue == 1 ? '确定' : 'Yes')
        })
    }

    const addNewBill = async (value) => {

        let billDetail = [{
            "开立票据名称": value.bill_detail_name,
            "身份证号": value.id_card,
            "TIN": value.TIN,
            "金额": value.amount,
            "用途": value.purpose,
            "备注": value.remark,
            // @tmpdel
            // "非陆籍填1": value.outland,
            // "法人填1，自然人不填": value.natural_legal,
            "志工编号": value.volunteer_code,
            "志工姓名": value.volunteer_name,
            "手机号": value.phone,
            "地址": value.address,
            "Email": value.email,
        }]
        let area = value.area;
        let uname = sessionStorage.getItem('uname');
        let uid = sessionStorage.getItem('uid');

        let { data } = await axios.post('/fund/bill/addNewBillRecord', {
            billDetail,
            area,
            uid,
            uname,
        });
        // console.log('addNewBillRecord:', data);

        if (data?.code == 1) {
            Modal.info({
                title: langValue == 0 ? (data?.msg + data.en_msg) : (langValue == 1 ? data?.msg : data.en_msg),
                okText: langValue == 0 ? '知道了Yes' : (langValue == 1 ? '知道了' : 'Yes'),
                onOk: () => {
                    // 关闭modal 清空form
                    setAddOpen(false);
                    addForm.resetFields();
                }
            })
        } else {
            Modal.error({ title: langValue == 0 ? '提交失败Submission failed' : (langValue == 1 ? '提交失败' : 'Submission failed'), okText: langValue == 0 ? '知道了Yes' : (langValue == 1 ? '知道了' : 'Yes') })
        }

    }

    const rowSelection = {
        alwaysShowAlert: true,
        onChange: (selectedRowKeys, selectedRows) => {
            // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            setSelectedRowkeysArr([...selectedRowKeys]);
            setSelectedRowArr([...selectedRows]);
        },

        getCheckboxProps: (record) => ({
            disabled: record['状态'] != '正常', // 改行checkbox不能被勾选
            name: record.name,
        }),
    };

    //批量红冲
    // const batchReverse = async () => {
    //     // console.log('批量红冲:', selectedRowArr, selectedRowKeysArr);
    //     setBrmVisible(true);
    //     setBillDetailList(selectedRowArr);
    // }

    // const relateReverseBill = () => {
    //     //关联红冲发票
    //     // console.log('关联红冲发票:', selectedRowArr, selectedRowKeysArr);
    //     setRmVisible(true);
    //     setBillDetailList(selectedRowArr);
    // }


    useEffect(() => {
        // 在组件卸载时执行
        (async function () {
            if (!areaData || !areaData.length) {
                //若无地区，初始化地区列表
                let areaData = await axios.post('/fund/area/getAll');
                // console.log('getAreaOpt:', data);
                if (areaData?.data?.data) {
                    // 地区选择框
                    setareaData(areaData.data.data)
                }
            }
            if (!projectData || !projectData.length) {
                //若无项目，初始化项目列表
                let data = await queryAxios('/project/list')
                let pdata = data.data.data;
                pdata = pdata.map(p => p['捐款项目'])
                setProjectData(pdata);
            }
        })()
        return () => {
            setFileData([]);
        };

    }, [])
    // 中英文切换
    const getColumns = (col) => {
        let newCol = [...col];
        // console.log(newCol);
        newCol.forEach((item, i) => {
            let { dataIndex } = item;
            if (i == 1) {
                item.renderFormItem = () => {
                    return <RangePicker
                        format="YYYY-MM-DD"
                        // disabledDate={disabledDate}
                        placeholder={langValue == 0 ? ['开始日期Start Date', '结束日期End Date'] : (langValue == 1 ? ['开始日期', '结束日期'] : ['Start Date', 'End Date'])}
                    />
                }
                item.formItemProps = {
                    label: langValue == 0 ? <>捐款日期<br />Donation date</> : (langValue == 1 ? '捐款日期' : 'Donation date')
                }
            }
            if (dataIndex == '票据名称') {
                item.renderFormItem = () => {
                    return (
                        <Input placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} />
                    )
                }
            }
            if (dataIndex == '捐款项目') {
                item.render = (_, item2) => {
                    return <span>{item2['捐款项目']}</span>
                }
                item.renderFormItem = () => {
                    return <Select
                        placeholder={langValue == 0 ? '請選擇捐款項目Please select Donation items' : (langValue == 1 ? '請選擇捐款項目' : 'Please select Donation items')}
                        style={{ width: 200 }}
                        allowClear
                        showSearch
                        dropdownMatchSelectWidth={false}
                        onChange={(value) => {
                            setChoosenProject(value)
                        }}
                    >
                        {projectData.map((projectName, i) => {
                            return <Option key={projectName} value={projectName}>{projectName}</Option>
                        })}
                    </Select>
                };
            }
            if (dataIndex == '地区') {
                item.renderFormItem = () => {
                    return <Select
                        placeholder={langValue == 0 ? '請選擇地區Please select region' : (langValue == 1 ? '請選擇地區' : 'Please select region')}
                        style={{ width: 300 }}
                        mode="multiple"
                        allowClear
                        showSearch
                        onChange={selectArea}
                    >
                        {areaData.map((area, i) => {
                            return <Option key={area.area} value={area.areaCode + '-' + area.areaName}>{area.areaCode + ' ' + area.areaName}</Option>
                        })}
                    </Select>
                };
            }
            if (dataIndex == "票据号段") {
                item.renderFormItem = (_, config, form) => {
                    // console.log("rfi", config, form);
                    let msg = null;
                    let combine = (form) => {
                        let vals = form.getFieldsValue(true);
                        let { startNum, endNum } = vals;
                        if (!startNum || 'undefined' == startNum) {
                            startNum = '';
                        }
                        if (!endNum || 'undefined' == endNum) {
                            endNum = '';
                        }
                        console.log(`combine start:${startNum},end:${endNum}`, typeof startNum, typeof endNum)

                        form.setFieldsValue({ "票据号段": startNum + '|' + endNum });
                    };
                    return (
                        <React.Fragment>
                            {/* <input id="num-ranger-summary" type='hidden' /> */}
                            <div className='num-ranger'>
                                <input size='22' id='start-num' placeholder={langValue == 0 ? '起始号段Starting number segment' : (langValue == 1 ? '起始号段' : 'Starting number segment')}
                                    onChange={(e) => {
                                        // console.log('start onchange ***', e.target.value);
                                        // console.log("start onChange, form:", form.getFieldsValue(true));
                                        let sn = e.target.value;
                                        if (sn) {
                                            sn = sn.trim();
                                        } else {
                                            sn = '';
                                        }
                                        form.setFieldsValue({ "startNum": sn });
                                        combine(form);
                                    }}
                                />
                                <span>→</span>
                                <input size='22' id='end-num' placeholder={langValue == 0 ? '结束号段Ending number segment' : (langValue == 1 ? '结束号段' : 'Ending number segment')}
                                    // disabled={!form.getFieldsValue(true) ?.startNum}
                                    // onClick={() => { alert('focus') }}
                                    onChange={(e) => {
                                        // console.log('end onchange ***', e.target.value);
                                        // console.log("end onChange, form:", vals);
                                        let en = e.target.value;
                                        if (en) {
                                            en = en.trim();
                                        } else {
                                            en = '';
                                        }
                                        form.setFieldsValue({ "endNum": en });
                                        combine(form);
                                    }}
                                />
                            </div>
                            {/* <div>{msg}</div> */}
                        </React.Fragment>
                    )
                }
            }
            if (dataIndex == "志工编号") {
                item.renderFormItem = (_, record, form) => {
                    return (
                        <Select
                            onClick={() => {
                                if (volunArr.length < 1) {
                                    let msg = langValue == 0 ? <>先請選擇地區！<br />Please select region !</> : (langValue == 1 ? '請選擇地區！' : 'Please select region!')
                                    return message.warn(msg)
                                }
                            }}
                            placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
                            showSearch
                            allowClear
                            style={{ width: 200 }}
                            onChange={(val) => {
                                setVolcode(val);
                                if (!val) {
                                    //清空编号，则同时清空姓名
                                    form.setFieldsValue({ ['志工姓名']: null, ['志工英文名']: null })
                                    setVolEnName(null);
                                    setVolname(null);
                                    return;
                                }
                                let v = volunArr.filter(v => v.volunteer_code == val);
                                if (v && v.length) {
                                    let { vol_en_name = null, volunteer_name = null } = v[0];
                                    setVolEnName(vol_en_name);
                                    setVolname(volunteer_name);
                                    form.setFieldsValue({ ['志工姓名']: volunteer_name, ['志工英文名']: vol_en_name })
                                }
                            }}
                        >
                            {volunArr.map((item2, index) => {
                                return <Option key={index} value={item2.volunteer_code}>{item2.volunteer_code}</Option>
                            })}
                        </Select>
                    )
                }


            }
            if (dataIndex == "志工姓名") {
                item.renderFormItem = (_, record, form) => {
                    return (
                        <Input placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')}
                            onChange={(e) => {
                                console.log('志工姓名onchange：', e.target.value)
                                form.setFieldsValue({ '志工姓名': e.target.value })
                                setVolname(e.target.value);
                            }}
                        />
                    )

                }
            }
            if (dataIndex == "志工英文名") {
                item.renderFormItem = (_, record, form) => {
                    return (
                        <Input placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')}
                            onChange={(e) => {
                                console.log('志工英文名onchange：', e.target.value)
                                form.setFieldsValue({ '志工英文名': e.target.value })
                                setVolEnName(e.target.value)
                            }}
                        />
                    )
                }
            }
            if (dataIndex == '状态') {
                item.renderFormItem = () => {
                    return <Select
                        placeholder={langValue == 0 ? '请选择状态Please select status' : (langValue == 1 ? '请选择状态' : 'Please select status')}
                    >
                        <Option key='all' value={null}>{langValue == 0 ? '所有状态All status' : (langValue == 1 ? '所有状态' : 'All status')}</Option>
                        <Option key='0' value='0'>{langValue == 0 ? '正常Active' : (langValue == 1 ? '正常' : 'Active')}</Option>
                        <Option key='-1' value='-1'>{langValue == 0 ? '已作废Void' : (langValue == 1 ? '已作废' : 'Void')}</Option>
                        <Option key='10' value='10'>{langValue == 0 ? '重新开具Reissued' : (langValue == 1 ? '重新开具' : 'Reissued')}</Option>
                    </Select>
                }
                item.render = (_, item2) => {
                    return langValue == 0 ? <span>{item2['状态']}<br />{item2.en_status}</span> : (langValue == 1 ? item2['状态'] : item2.en_status)
                }
            }
            // if (i == 12) {
            //     item.render = (_, item2) => {
            //         return <span>{item2['作废原因']}</span>
            //     }
            // }
            if (dataIndex == '备注') {
                item.renderFormItem = () => {
                    return (
                        <Input placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')}
                            onChange={(e) => setRemark(e.target.value)} />
                    )
                }
            }

            item.title = langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)
        })
        let operCol = {
            title: '操作',
            en_title: 'Operation',
            ch_title: '操作',
            valueType: 'option',
            fixed: 'right',
            width: '90px',
            render: (text, record, _, action) => {
                let isNormal = record['状态'] == '正常';
                let isReissued = record['状态'] == '重新开具';
                let voidable = isNormal || isReissued;//可以作废
                return [
                    <a
                        key="abtandrecreact"
                        // disabled={((record['状态'] !== '正常')) && (!record['关联号码'])}
                        disabled={(!isNormal) || isReissued || !record['票据号码']}
                        onClick={() => {
                            if (isNormal && (!isReissued)) {
                                setModalData(record);
                                setOpen(true);
                            }

                        }}
                    >
                        {langValue == 0 ? '作废并重开Cancel&Reissue' : (langValue == 1 ? '作废并重开' : 'Cancel&Reissue')}
                    </a>,
                    <a
                        key="Void" style={{ color: voidable ? 'red' : '#bfbfbf' }}
                        disabled={!voidable || !record['票据号码']}
                        onClick={() => {
                            console.log('record:*', record);
                            if (!voidable) {
                                console.log('仅状态为“正常”或“重新开具”的发票可作废');
                                return;
                            }
                            Modal.confirm({
                                title: langValue == 0 ? '确定作废该票据Sure To avoid?' : (langValue == 1 ? '确定作废该票据？' : 'Sure To avoid?'),
                                content: <div>
                                    请输入作废原因：<input id='please_enter_void_reason' />
                                </div>,
                                okText: langValue == 0 ? '确定Yes' : (langValue == 1 ? '确定' : 'Yes'),
                                cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
                                onOk: async () => {
                                    let rsele = document.getElementById('please_enter_void_reason');
                                    let reason = rsele?.value;
                                    if (!reason || !reason.trim()) {
                                        Modal.warn('请先输入作废原因')
                                        return;
                                    }
                                    mask();
                                    let { bill_detail_id, 开立日: bill_date, 状态: ori_status } = record;
                                    let { data } = await axios.post('/fund/billmgt/voidInvoice',
                                        { bill_detail_id, bill_date, ori_status, reason }, { timeout: 60000 });
                                    unmask();
                                    if (data && data.ret == 0) {
                                        Modal.info({
                                            title: `作废成功`,
                                            onOk: () => {
                                                //清空表单，刷新页面
                                                form.resetFields();
                                                actionRef.current.reload();
                                            }
                                        })
                                    } else {
                                        if (data.msg) {
                                            Modal.warn({
                                                title: data.msg
                                            })
                                        }
                                    }
                                }
                            })
                        }}
                    >
                        {langValue == 0 ? '作废Void' : (langValue == 1 ? '作废' : 'Void')}
                    </a>

                ]
            }
        };
        newCol.push(operCol)
        return newCol
    }
    // 
    // if (langValue == 0) {
    //     redstr = (
    //         <div style={{ fontSize: 14, color: 'red', display: 'flex', flexDirection: 'column', marginTop: '5px' }}>
    //             <span>双击正常发票可新建红冲，双击已关联的红冲发票可查看/编辑</span>
    //             <span>Double-click a normal invoice to create a new red-refund, double-click an associated red-refund invoice to view/edit</span>
    //         </div>
    //     )
    // } else if (langValue == 1) {
    //     redstr = (
    //         <div style={{ fontSize: 14, color: 'red', display: 'flex', flexDirection: 'column', marginTop: '5px' }}>
    //             <span>双击正常发票可新建红冲，双击已关联的红冲发票可查看/编辑</span>
    //         </div>
    //     )
    // } else {
    //     redstr = (
    //         <div style={{ fontSize: 14, color: 'red', display: 'flex', flexDirection: 'column', marginTop: '5px' }}>
    //             <span>Double-click a normal invoice to create a new red-refund, double-click an associated red-refund invoice to view/edit</span>
    //         </div>
    //     )
    // }

    // 打印单张发票
    const InvoicePrintPre = () => {
        // 转换虚拟尺寸为物理尺寸
        // const regex = /\b\d+(?:\.\d+)?px\b/g
        // let arr = htmlstyle.split(regex)
        // console.log(arr);
        // let matches = [...htmlstyle.matchAll(regex)]
        // let stylestr = htmlstyle
        // matches.forEach((match,index)=>{
        //     // 转换物理尺寸
        //     let num = Number(match[0].split('p')[0])
        //     let newnum = (num*3/4) + 'pt'
        //     let str = stylestr.slice(0,match.index)
        //     let len = match[0].length
        //     let str2 = stylestr.slice(index+len)
        //     stylestr = str+newnum+str2
        //     console.log(`第 ${index + 1} 个匹配项: "${match[0]}" 在索引 ${match.index}`)
        // })
        // console.log(stylestr);
        printJS({
            printable: 'htmlstr',
            type: 'html',
            targetStyles: ['*'],
            documentTitle: `发票`,
            scanStyles: false,
            style: htmlstyle
        })
        // setModalVisible(false)
    }

    const statisticable = (d) => {
        return d['状态'] && d['状态'] != '已作废';
    }

    return (
        <div className='donation-list' id="donation-list">

            <ProTable
                scroll={{ x: 'max-content' }}
                rowSelection={rowSelection}
                // sticky
                formRef={formRef}
                actionRef={actionRef}
                cardBordered
                // toolBarRender={false}
                toolbar={{
                    actions: [
                        <>
                            <div style={{ fontSize: 20, fontWeight: 600 }}>
                                <span style={{ marginLeft: 0 }}>{langValue == 0 ? '總金額(Total amount valid)' : (langValue == 1 ? '總金額' : 'Total amount')}：{amount}</span>
                                <span style={{ marginLeft: 40 }}>{langValue == 0 ? '合計有效筆數(Total number of transactions valid)' : (langValue == 1 ? '合計有效筆數' : 'Total number of transactions valid')}：{totalCount}</span>
                                {/* {redstr} */}
                            </div>
                            {/* <Button className='download-btn' type='primary'
                                onClick={relateReverseBill}
                                disabled={!selectedRowKeysArr.length}//没有数据时不能下载
                            > {langValue == 0 ? <span>关联红冲发票<br />Associated red invoices</span> : (langValue == 1 ? '关联红冲发票' : 'Associated red invoices')}
                            </Button>
                            <Button className='download-btn' type='danger'
                                onClick={batchReverse}
                                disabled={!selectedRowKeysArr.length}//没有数据时不能下载
                            > {langValue == 0 ? <span>批量红冲<br />Batch red invoices</span> : (langValue == 1 ? '批量红冲' : 'Batch red invoices')}
                            </Button> */}
                            <Button className='download-btn' type='primary' icon={<DownloadOutlined />}
                                onClick={() => {
                                    message.destroy();//清空消息提示
                                    Modal.confirm({
                                        title: langValue == 0 ? '確定要下載嗎？' : (langValue == 1 ? '確定要下載嗎？' : 'Do you have to download it?'),
                                        onOk: () => { handleDownload(); },
                                        okText: langValue == 0 ? '知道了Yes' : (langValue == 1 ? '知道了' : 'Yes'),
                                    })
                                }}
                                disabled={fileData.length == 0}//没有数据时不能下载
                            > {langValue == 0 ? <span>會員活動報告<br />Member Activity Report</span> : (langValue == 1 ? '會員活動報告' : 'Member Activity Report')}
                            </Button>
                            <Button className='download-btn' type='primary' icon={<DownloadOutlined />}
                                onClick={countHandle}

                            > {langValue == 0 ? <span>年項目報表<br />Annual Project Report</span> : (langValue == 1 ? '年項目報表' : 'Annual Project Report')}
                            </Button>
                            <Button className='download-btn' type='primary' icon={<DownloadOutlined />}
                                onClick={countHandle2}

                            > {langValue == 0 ? <span>年捐贈報表<br />Annual donation list</span> : (langValue == 1 ? '年捐贈報表' : 'Annual donation list')}
                            </Button>
                        </>
                    ]
                }}
                //工具栏选项
                options={{
                    density: true,//工具栏选择表格密度
                    fullScreen: true,//工具栏允许全屏
                    reload: false,//工具栏刷新
                    setting: false,
                }}
                request={async (
                    // 第一个参数 params 查询表单和 params 参数的结合
                    // 第一个参数中一定会有 pageSize 和  current ，这两个参数是 antd 的规范
                    params: {
                        pageSize: number;
                        current: number;
                    },
                    sort,
                    filter,
                ) => {
                    // 这里需要返回一个 Promise,在返回之前你可以进行数据转化
                    // 如果需要转化参数可以在这里进行修改
                    // console.log('pro table params:', params, ' sort:', sort, ' filter:', filter);
                    //重置checkbox
                    actionRef.current.clearSelected();


                    const coverParams = (params) => {
                        console.log('params:', params)
                        let p;
                        setDateRange(params.开立日);
                        // let { area } = { area: params['地区'] };
                        let { billDetailName } = { billDetailName: params['票据名称'] };
                        let { billDate } = { billDate: params['开立日'] };
                        let { billCode } = { billCode: params['票据号段'] };
                        // let { volunteerCode } = { volunteerCode: params['志工编号'] };
                        // let { volunteerName } = { volunteerName: params['志工姓名'] };
                        let { status } = { status: params['状态'] };
                        // if (area) {

                        //     area = area.map(item=>item.split('-').join(''))
                        //     p = { ...p, area };
                        // }
                        if (choosenArea) {
                            p = { ...p, area: choosenArea }
                        }
                        if (volEnName) {
                            p = { ...p, vol_en_name: volEnName }
                        }
                        if (volcode) {
                            p = { ...p, volunteerCode: volcode }
                        }
                        if (volname) {
                            p = { ...p, volunteerName: volname }
                        }
                        if (billDetailName) {
                            p = { ...p, billDetailName };
                        }
                        if (billDate) {
                            p = { ...p, billDate };
                        }
                        if (billCode) {
                            p = { ...p, billCode };
                        }
                        if (remark) {
                            p = { ...p, remark }
                        }
                        // if (volunteerCode) {
                        //     p = { ...p, volunteerCode };
                        // }
                        // if (volunteerName) {
                        //     p = { ...p, volunteerName };
                        // }
                        if (status) {
                            p = { ...p, status };
                        }
                        p.purpose = choosenProject;
                        // console.log('param:', p)
                        return p;
                    }

                    if (!params['开立日'] && !choosenArea?.length) {
                        console.log('***params:', params)
                        message.warn('请先选择起始日期');
                        return false;
                    }
                    let inparams = coverParams(params);
                    const data = await axios.post('/fund/donation/donationList', inparams);
                    // console.log('request:', data);
                    setDownloadParams(coverParams(params));

                    const { list } = data.data;
                    let dataSrc = [...list];

                    // 获取所有地区，并渲染选择框
                    let areaData = await axios.post('/fund/area/getAll');
                    // console.log('getAreaOpt:', data);
                    if (areaData?.data?.data) {
                        // 地区选择框
                        setareaData(areaData.data.data)
                    }


                    // 设置下载的excel所需数据
                    setFileData(dataSrc);

                    //合计笔数
                    // console.log('合计笔数:', dataSrc?.length);
                    setTotalCount(dataSrc?.filter(d => statisticable(d))?.length);

                    //總金額
                    let totalAmount = 0;

                    dataSrc.forEach((d, i) => {
                        d['序号'] = i + 1;
                        d.key = i + 1;
                        if (d['来源地'] == '1') {
                            d['来源地'] = '境外';
                        } else {
                            d['来源地'] = '境内';
                        }
                        if (d['身份'] == '1') {
                            d['身份'] = '法人';
                        } else {
                            d['身份'] = '自然人';
                        }
                        d.en_Id = IdObj[d['身份']]
                        d.en_proj = d['捐款项目']
                        d.en_status = statusObj[d['状态']]
                        //
                        if (statisticable(d) && typeof Number(d['票据金额']) == 'number') {
                            totalAmount = Number(Number(d['票据金额']).toFixed(2)) + Number(totalAmount.toFixed(2));
                            totalAmount = Number(totalAmount.toFixed(2));
                        }
                    });
                    // console.log('總金額:', totalAmount);
                    setAmount(totalAmount);

                    return {
                        data: dataSrc,
                        // success 请返回 true，
                        // 不然 table 会停止解析数据，即使有数据
                        success: true,
                        // 不传会使用 data 的长度，如果是分页一定要传
                        total: dataSrc.length,
                    };
                    // }
                }}
                // editable={{
                //     type: 'multiple',
                // }}
                columns={getColumns(col)}
                // 是否需要手动触发首次请求
                manualRequest={true}
                columnsState={{
                    persistenceKey: 'pro-table-singe-demos',
                    persistenceType: 'sessionStorage',
                }}
                // rowKey="序号"//不写用默认值，这里貌似用
                search={{
                    labelWidth: 'auto',
                    span: '2',//一行几个搜索控件
                    collapseRender: false,//隐藏收起按钮
                    searchText: langValue == 0 ? '查询Query' : (langValue == 1 ? '查询' : 'Query'),
                    resetText: langValue == 0 ? '重置Reset' : (langValue == 1 ? '重置' : 'Reset'),
                }}
                pagination={{
                    pageSizeOptions: [10, 20, 50, 100, 1000],
                    showQuickJumper: true,
                    showSizeChanger: true,
                }}
                dateFormatter="string"
                // headerTitle="筛选结果"
                onRequestError={(error) => {
                    //请求error的回调处理
                    console.log(error);
                    error = typeof error == 'object' ? JSON.stringify(error) : error;
                    Modal.error({ title: langValue == 0 ? '表格加载错误Table loading error' : (langValue == 1 ? '表格加载错误' : 'Table loading error') });
                }}
                tableAlertRender={({ selectedRowKeys, selectedRows, onCleanSelected }) => (
                    <Space size={24}>
                        <span>
                            {langValue == 0 ? `已选${selectedRowKeys.length}项 Selected ${selectedRowKeys.length} items` : (langValue == 1 ? `已选${selectedRowKeys.length}项` : `Selected ${selectedRowKeys.length} items`)}

                            {selectedRowKeys.length ? (<a style={{ marginLeft: 8 }} onClick={onCleanSelected}>
                                {langValue == 0 ? '取消选择Unselected' : (langValue == 1 ? '取消选择' : 'Unselected')}
                            </a>) : null}

                        </span>
                    </Space>
                )}
                tableAlertOptionRender={false}
            />


            <Modal
                title={langValue == 0 ? '作废并重开发票Void and reissue invoices' : (langValue == 1 ? '作废并重开发票' : '作废并重开发票Void and reissue invoices')}
                centered
                visible={open}
                onCancel={() => {
                    setModalData(null);
                    form.resetFields();
                    setOpen(false);
                }}
                footer={null}
                maskClosable={false}
                width={'100%'}
            >
                <table className='red_bill_table'>
                    <tbody>
                        <tr><th colSpan={13} className='bill_title'>{langValue == 0 ? '原发票Original invoice' : (langValue == 1 ? '原发票' : 'Original invoice')}</th></tr>
                        <tr>
                            {donListCol.filter(item => item.dataIndex != '票据号段' && item.dataIndex != '身份' && item.dataIndex != '红冲关联数' && item.dataIndex != '状态'
                            ).map(item => {
                                return (
                                    <th key={item.dataIndex}>{langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)}</th>
                                )
                            })}
                        </tr>
                        <tr>
                            <td>{modalData?.['票据号码']}</td>
                            <td>{modalData?.['开立日']}</td>
                            <td>{modalData?.['票据名称']}</td>
                            <td>{modalData?.['票据金额']}</td>
                            <td>{modalData?.['捐款项目']}</td>
                            <td>{modalData?.['地区']}</td>
                            <td>{modalData?.['志工编号']}</td>
                            <td>{modalData?.['志工姓名']}</td>
                            <td>{modalData?.['手机号码']}</td>
                            <td>{modalData?.['邮箱']}</td>
                            <td style={{ color: 'red' }}>{redBillReason}</td>
                            {/* <td style={{ color: 'red' }}>{redBillCode}</td>
                            <td>{modalData ?.['原票日期'] || '-'}</td> */}
                        </tr>
                        <tr><th colSpan={12} className='bill_title'>{langValue == 0 ? '新开发票Reissued invoice' : (langValue == 1 ? '新开发票' : 'Reissued invoice')}</th></tr>
                        <tr>
                            {donListCol.filter(item => item.dataIndex != '票据号段' && item.dataIndex != '身份' && item.dataIndex != '红冲关联数' && item.dataIndex != '状态').map(item => {
                                return (
                                    <th key={item.dataIndex}>{langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)}</th>
                                )
                            })}
                        </tr>
                        <tr>
                            <td style={{ color: 'red' }}>{redBillCode}</td>
                            <td style={{ color: 'red' }}>{moment().format('YYYY-MM-DD')}</td>
                            <td>{modalData?.['票据名称']}</td>
                            <td >{Number(modalData?.['票据金额'])}</td>
                            <td>{modalData?.['捐款项目']}</td>
                            <td>{modalData?.['地区']}</td>
                            <td>{modalData?.['志工编号']}</td>
                            <td>{modalData?.['志工姓名']}</td>
                            <td>{modalData?.['手机号码']}</td>
                            <td>{modalData?.['邮箱']}</td>
                            <td >-</td>
                            {/* <td style={{ color: 'red' }}>{modalData ?.['票据号码']}</td>
                            <td style={{ color: 'red' }}>{modalData ?.['开立日']}</td> */}
                        </tr>
                    </tbody>
                </table>

                <div className='add_red_bill'>
                    <div>
                        <span className='form_title'>{langValue == 0 ? '新开发票Reissue invoice' : (langValue == 1 ? '新开发票' : 'Reissue invoice')}</span>
                        <Form
                            name="form"
                            onFinish={onFinish}
                            form={form}
                            requiredMark={false}
                            style={{ marginTop: 12 }}
                        >
                            <Form.Item
                                name='bill_code'
                                rules={[{ required: true, message: '请输入！' }]}
                            >
                                <Input style={{ minWidth: 600 }}
                                    placeholder={langValue == 0 ? '请输入新发票号码(打印用)Please enter the reissue invoice number(for print)' : (langValue == 1 ? '请输新发票号码(打印用)' : 'Please enter the reissue invoice number(for print)')}
                                    autoComplete="off"
                                    onChange={(e) => { setRedBillCode(e.target.value) }}
                                >
                                </Input>
                            </Form.Item>
                            <Form.Item
                                name='reason'
                            >
                                <Input style={{ minWidth: 600 }}
                                    placeholder={langValue == 0 ? '请输入重新开票原因Please enter why reissue the invoice' : (langValue == 1 ? '请输入重新开票原因' : 'Please enter why reissue the invoice')}
                                    onChange={(e) => { setRedBillReason(e.target.value) }}
                                >
                                </Input>
                            </Form.Item>
                            <Button
                                className='submit_btn'
                                type='primary'
                                htmlType="submit"
                            >
                                {langValue == 0 ? '提交Submit' : (langValue == 1 ? '提交' : 'Submit')}
                            </Button>
                        </Form>
                    </div>
                </div>
            </Modal>


            <Modal
                title={langValue == 0 ? '新建票据Create a New Ticket' : (langValue == 1 ? '新建票据' : 'Create a New Ticket')}
                centered
                visible={addOpen}
                onCancel={() => {
                    addForm.resetFields();
                    setAddOpen(false);
                }}
                footer={null}
                maskClosable={false}
                width={'100%'}
            >
                <div className='add_new_bill'>
                    <Form
                        name="add_form"
                        onFinish={addOnFinish}
                        form={addForm}
                        requiredMark={false}
                    >
                        <table className='new_bill_table'>
                            <tbody>
                                <tr><th colSpan={15} className='bill_title'>{langValue == 0 ? '原票据Original bill' : (langValue == 1 ? '原票据' : 'Original bill')}</th></tr>
                                <tr>
                                    {addBillCols.map(item => {
                                        if (item.dataIndex == '邮箱') return (<th key={item.dataIndex}>{item.title}</th>)
                                        return (
                                            <th key={item.dataIndex}>{langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)}</th>
                                        )
                                    })}
                                </tr>
                                <tr>
                                    <td>{billData?.bill_date ? moment(billData?.bill_date).format('YYYY-MM-DD') : ''}</td>
                                    <td>{billData?.bill_detail_name}</td>
                                    <td>{billData?.id_card}</td>
                                    <td>{billData?.credit_code}</td>
                                    <td>{billData?.amount}</td>
                                    <td>{billData?.purpose}</td>
                                    <td>{billData?.remark}</td>
                                    <td>{billData?.area}</td>
                                    <td>{billData?.volunteer_code}</td>
                                    <td>{billData?.volunteer_name}</td>
                                    <td>{billData?.phone}</td>
                                    <td>{billData?.email}</td>
                                </tr>
                                <tr><th colSpan={15} className='bill_title'>{langValue == 0 ? '新票据New bill' : (langValue == 1 ? '新票据' : 'New bill')}</th></tr>
                                <tr>
                                    {addBillCols.map(item => {
                                        if (item.dataIndex == '邮箱') return (<th key={item.dataIndex}>{item.title}</th>)
                                        return (
                                            <th key={item.dataIndex}>{langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)}</th>
                                        )
                                    })}
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Item
                                            name='bill_date'
                                        >
                                            <Input
                                                autoComplete="off"
                                                disabled
                                            >
                                            </Input>
                                        </Form.Item>
                                    </td>
                                    <td>
                                        <Form.Item
                                            name='bill_detail_name'
                                            rules={[{ required: true, message: '请输入！' }]}
                                        >
                                            <Input
                                                autoComplete="off"
                                            >
                                            </Input>
                                        </Form.Item>
                                    </td>
                                    <td>
                                        <Form.Item
                                            name='id_card'
                                        >
                                            <Input
                                                autoComplete="off"
                                            >
                                            </Input>
                                        </Form.Item>
                                    </td>
                                    <td>
                                        <Form.Item
                                            name='credit_code'
                                        >
                                            <Input
                                                autoComplete="off"
                                            >
                                            </Input>
                                        </Form.Item>
                                    </td>
                                    <td>
                                        <Form.Item
                                            name='amount'
                                            rules={[{ required: true, message: '请输入！' }]}
                                        >
                                            <InputNumber style={{ width: 100 }}>
                                            </InputNumber>
                                        </Form.Item>
                                    </td>
                                    <td>
                                        <Form.Item
                                            name='purpose'
                                        >
                                            <Input
                                                autoComplete="off"
                                                disabled
                                            >
                                            </Input>
                                        </Form.Item>
                                    </td>
                                    <td>
                                        <Form.Item
                                            name='remark'
                                        >
                                            <Input
                                                autoComplete="off"
                                            >
                                            </Input>
                                        </Form.Item>
                                    </td>
                                    <td>
                                        <Form.Item
                                            name='area'
                                        >
                                            <Input
                                                autoComplete="off"
                                                disabled
                                            >
                                            </Input>
                                        </Form.Item>
                                    </td>
                                    <td>
                                        <Form.Item
                                            name='volunteer_code'
                                        >
                                            <Input
                                                autoComplete="off"
                                                disabled
                                            >
                                            </Input>
                                        </Form.Item>
                                    </td>
                                    <td>
                                        <Form.Item
                                            name='volunteer_name'
                                        >
                                            <Input
                                                autoComplete="off"
                                                disabled
                                            >
                                            </Input>
                                        </Form.Item>
                                    </td>
                                    <td>
                                        <Form.Item
                                            name='phone'
                                        >
                                            <Input
                                                autoComplete="off"
                                            >
                                            </Input>
                                        </Form.Item>
                                    </td>
                                    <td>
                                        <Form.Item
                                            name='email'
                                        >
                                            <Input
                                                autoComplete="off"
                                            >
                                            </Input>
                                        </Form.Item>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <Button
                            className='submit_btn'
                            type='primary'
                            htmlType="submit"
                        >
                            {langValue == 0 ? '提交Submit' : (langValue == 1 ? '提交' : 'Submit')}
                        </Button>
                    </Form>

                </div>

            </Modal>
            <Modal
                centered
                visible={modalVisible}
                onOk={InvoicePrint}
                okText={langValue == 0 ? '打印Print' : (langValue == 1 ? '打印' : 'Print')}
                cancelText={langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle')}
                onCancel={() => setModalVisible(false)}
                width={'auto'}
                destroyOnClose={true}//关闭时清空（重新加载子组件）
                maskClosable={false}//点击遮罩不关闭
                closable={false}//不显示右上角的关闭按钮（X)
            >
                <DonationInvoice recordArr={yearData} />
            </Modal>
            <Modal
                centered
                visible={modalVisible2}
                onOk={InvoicePrint}
                okText={langValue == 0 ? '打印Print' : (langValue == 1 ? '打印' : 'Print')}
                cancelText={langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle')}
                onCancel={() => setModalVisible2(false)}
                width={'auto'}
                destroyOnClose={true}//关闭时清空（重新加载子组件）
                maskClosable={false}//点击遮罩不关闭
                closable={false}//不显示右上角的关闭按钮（X)
            >
                <DonationInvoiceForman recordArr={yearData} />
            </Modal>
            {/*
            <BatchReverseModal
                brmVisible={brmVisible}
                setBrmVisible={setBrmVisible}
                detailList={billDatailList}
                setBillDetailList={setBillDetailList}
                actionRef={actionRef}
            />

            <RelateReverseModal
                rmVisible={rmVisible}
                setRmVisible={setRmVisible}
                detailList={billDatailList}
                setBillDetailList={setBillDetailList}
                actionRef={actionRef}
            />

            {reverseBillRecord ? <EditRelRvsModal
                ermVisible={ermVisible}
                setErmVisible={setErmVisible}
                reverseBillRecord={reverseBillRecord}
                setReverseBillRecord={setReverseBillRecord}
                actionRef={actionRef}
            /> : null} */}


            <Modal
                centered
                visible={printModalVisible}
                onOk={InvoicePrintPre}
                okText={langValue == 0 ? '打印Print' : (langValue == 1 ? '打印' : 'Print')}
                cancelText={langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle')}
                onCancel={() => {
                    setPrintModalVisible(false);
                    form.resetFields();
                    actionRef.current.reload();
                }}
                width={'auto'}
                destroyOnClose={true}//关闭时清空（重新加载子组件）
                maskClosable={false}//点击遮罩不关闭
                closable={false}//不显示右上角的关闭按钮（X)
            >
                <Invoice recordArr={recordArr} />
            </Modal>

        </div >
    )
}
